/**
 * converting dataURI to binary.
 * @param {string} dataURI - the data you with co convert
 * @returns binary array
 */

const convertDataURIToBinary = (dataURI) => {
  var BASE64_MARKER = ";base64,";
  var base64Index = dataURI.indexOf(BASE64_MARKER);
  var base64 = dataURI.substring(base64Index);
  var raw = window.atob(base64);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));

  for (var i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
};

export default convertDataURIToBinary;
